import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';


const red = '#bb0000';
const grey ='#a2afb9';

const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    width:'100%',
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 250,
  },
  menu: {
    width: 200,
  },
  button: {
    paddingTop: 15,
    margin: 0,
    fontSize: 20,
    textAlign:'center',
    backgroundColor: red,
    color: '#ffffff',
    zIndex:10000,
  },
});


class TextFields extends React.Component {
    constructor(props){
      super(props)
      this.state={
        email:'',
      }
    }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });
  };

  handleOnClick = () => {
    this.props.clickFunc(this.state.email)
  }

  render() {
    const { classes } = this.props;

    let contactMessage = this.props.failed ?
      <div>
        <Typography variant="h2">登録されたEmailアドレスではありません。</Typography>
        <Typography variant="h2">お手数ですが、Avinton採用担当者へご連絡ください。</Typography>
        <Typography variant="h2">recruit@avinton.com</Typography>
      </div>
      : null


    return (
      <div>
        <h2>指定したEmailアドレスを入力してください。</h2>
        <Grid container spacing={12}>
          <div className={classes.container} noValidate autoComplete="off">
            <Grid item xs={3} />
            <Grid item xs={3}>
              <TextField
                id="email"
                label="email"
                className={classes.textField}
                value={this.state.email}
                onChange={this.handleChange('email')}
                margin="normal"
              />
            </Grid>
            <Grid item xs={3}>
              <Button variant="contained" color={grey} onClick={this.handleOnClick} className={classes.button}>
                Submit
              </Button>
            </Grid>
            <Grid item xs={3} />
          </div>
        </Grid>
        {contactMessage}
      </div>
    );
  }
}

TextFields.propTypes = {
  classes: PropTypes.object.isRequired,
  clickFunc:PropTypes.func.isRequired,
  failed:PropTypes.bool.isRequired,
};

export default withStyles(styles)(TextFields);



// WEBPACK FOOTER //
// ./src/components/Login/NonGoogleLoginForm.js